export default __webpack_public_path__ + "static/media/logoNIPEZ-EN.6fa0496d.svg";